import template from "./onboarding-directions.html";

export default angular
	.module("vesl.screens.welcome.onboarding-directions", [])
	.component("onboardingDirections", {
		bindings: {
			selectedAgency: "<"
		},
		template
	}).name;